import { Component, Inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

// import 'zone.js/plugins/zone-patch-rxjs';
import { DatabaseService } from './services/database.service';
import { TuitionFormComponent } from './component/tuition-form/tuition-form.component';
import { PromptUpdateService } from './services/prompt-update.service';
import { MetricsService } from './services/metrics.service';



@Component({
    selector: 'app-root',
    imports: [RouterOutlet, TuitionFormComponent],
    providers: [
        DatabaseService,
        PromptUpdateService,
        MetricsService,
        { provide: 'Window', useValue: window },
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent  {

    private window;
    constructor(
        private promptUpdateService: PromptUpdateService,
        private metricService: MetricsService,
        @Inject('Window') window: Window
    ) {
        this.window = window;
        metricService.initGA();
    }
    title = 'Financial Planning Estimator';
}
